import Http from "./Http";

class ImageService extends Http {
  static $displayName = "ImageService";

  resizeLoadedImages(ids) {
    return this.patch("/files/images/resize", ids);
  }

  static fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }
}

export default ImageService;
